import { UploadStatus } from "@/api/data";
import useSmartQueryClient from "@/hooks/useSmartQueryClient";
import ProgressBar from "./ProgressBar";
import useValidationMutations from "./useValidationMutations";

export interface ImportStepProps {
  UUID: string;
}

const UploadStatusTranslation: Record<UploadStatus, string> = {
  pending: "Preparing your file...",
  loading_data: "Loading into the platform...",
  validating_data: "Double-checking details...",
  importing_data: "Importing your data...",
  failed: "Import failed, please try uploading again",
  success: "All done, ready to use",
  uploading_validation_result: "Saving validation results...",
};

export default function ImportStep({ UUID }: ImportStepProps) {
  const smartQueryClient = useSmartQueryClient();
  const { progress, status } = useValidationMutations({
    parentPendingUUID: UUID,
    onCompleteFn: () => {
      smartQueryClient.invalidateBaseQueries();
    },
  });

  return (
    <ProgressBar
      status={status}
      progress={progress}
      uploadStatusTranslation={UploadStatusTranslation}
    />
  );
}
